import React, { useState, Suspense } from "react";

// Lazy load Layer 3 ของแต่ละ service
const AcneScarTreatment = React.lazy(() => import("./ServicesArtwork/AcneScarTreatment"));
const HairRemoval = React.lazy(() => import("./ServicesArtwork/DiodeHairRemoval"));
const UltraformerIII = React.lazy(() => import("./ServicesArtwork/Ultraformer-III"));
const MesoFat = React.lazy(() => import("./ServicesArtwork/MesoFatFace"));
const MesoFatBody = React.lazy(() => import("./ServicesArtwork/MesoFatBody"));
const Filler = React.lazy(() => import("./ServicesArtwork/Filler"));
const Botox = React.lazy(() => import("./ServicesArtwork/Botox"));
const Mesotherapy = React.lazy(() => import("./ServicesArtwork/Mesotherapy"));
const IVDripTherapy = React.lazy(() => import("./ServicesArtwork/IVStandard"));
const IVDripTherapyPremium = React.lazy(() => import("./ServicesArtwork/IVPremium"));
const LaserTreatment = React.lazy(() => import("./ServicesArtwork/Laser Treatment"));
const Treatment = React.lazy(() => import("./ServicesArtwork/Treatment"));
const Oligio = React.lazy(() => import("./ServicesArtwork/Oligio"));
const PRPTreatment = React.lazy(() => import("./ServicesArtwork/PRP"));
const NADDripTherapy = React.lazy(() => import("./ServicesArtwork/NAD+ Therapy"));
const FractoraGlow = React.lazy(() => import("./ServicesArtwork/FractoraGlowCO2"));
const RefinerySkinRadiance = React.lazy(() => import("./ServicesArtwork/RSR"));
const HairRevival = React.lazy(() => import("./ServicesArtwork/Hair-Revival"));

export default function ServicesArtwork({
  onBack,
  selectedCustomer,
  selectedUserId,
  userId, // ให้โพรพเหมือน MsgShortcut.jsx
}) {
  const [selectedService, setSelectedService] = useState(null);

  // เมนูตามลิสต์ที่ให้มา
  const services = [
    "Acne Scar Refining",
    "Botox",
    "Fractora Glow (CO²)",
    "Filler",
    "Hair Removal Laser",
    "Hair Revival",
    "IV Drip Therapy (Standard)",
    "IV Drip Therapy (Premium)",
    "Laser Treatment",
    "Meso Fat (Face)",
    "Meso Fat (Body)",
    "Mesotherapy",
    "NAD+ IV Drip Therapy",
    "PRP (Platelet-Rich Plasma)",
    "Refinery Skin Radiance (RSR)",
    "Oligio",
    "Treatment",
    "Ultraformer III",
  ];

  // ให้ component ตามชื่อ service
  const renderSelected = () => {
    switch (selectedService) {
      case "Acne Scar Refining":
        return (
          <AcneScarTreatment
            onBack={() => setSelectedService(null)}
            selectedCustomer={selectedCustomer}
            selectedUserId={selectedUserId}
            userId={userId}
          />
        );
      case "Hair Revival":
        return (
          <HairRevival
            onBack={() => setSelectedService(null)}
            selectedCustomer={selectedCustomer}
            selectedUserId={selectedUserId}
            userId={userId}
          />
          );
      case "IV Drip Therapy (Premium)":
        return (
          <IVDripTherapyPremium
            onBack={() => setSelectedService(null)}
            selectedCustomer={selectedCustomer}
            selectedUserId={selectedUserId}
            userId={userId}
          />
          );
      case "Refinery Skin Radiance (RSR)":
        return (
          <RefinerySkinRadiance
            onBack={() => setSelectedService(null)}
            selectedCustomer={selectedCustomer}
            selectedUserId={selectedUserId}
            userId={userId}
          />
          );
      case "Fractora Glow (CO²)":
        return (
          <FractoraGlow
            onBack={() => setSelectedService(null)}
            selectedCustomer={selectedCustomer}
            selectedUserId={selectedUserId}
            userId={userId}
          />
          );
      case "PRP (Platelet-Rich Plasma)":
        return (
          <PRPTreatment
            onBack={() => setSelectedService(null)}
            selectedCustomer={selectedCustomer}
            selectedUserId={selectedUserId}
            userId={userId}
          />
          );
      case "NAD+ IV Drip Therapy":
        return (
          <NADDripTherapy
            onBack={() => setSelectedService(null)}
            selectedCustomer={selectedCustomer}
            selectedUserId={selectedUserId}
            userId={userId}
          />
              );
      case "Hair Removal Laser":
        return (
          <HairRemoval
            onBack={() => setSelectedService(null)}
            selectedCustomer={selectedCustomer}
            selectedUserId={selectedUserId}
            userId={userId}
          />
        );
      case "Ultraformer III":
        return (
          <UltraformerIII
            onBack={() => setSelectedService(null)}
            selectedCustomer={selectedCustomer}
            selectedUserId={selectedUserId}
            userId={userId}
          />
        );
      case "Meso Fat (Face)":
        return (
          <MesoFat
            onBack={() => setSelectedService(null)}
            selectedCustomer={selectedCustomer}
            selectedUserId={selectedUserId}
            userId={userId}
          />
        );
      case "Meso Fat (Body)":
        return (
          <MesoFatBody
            onBack={() => setSelectedService(null)}
            selectedCustomer={selectedCustomer}
            selectedUserId={selectedUserId}
            userId={userId}
          />
        );
      case "Filler":
        return (
          <Filler
            onBack={() => setSelectedService(null)}
            selectedCustomer={selectedCustomer}
            selectedUserId={selectedUserId}
            userId={userId}
          />
        );
      case "Botox":
        return (
          <Botox
            onBack={() => setSelectedService(null)}
            selectedCustomer={selectedCustomer}
            selectedUserId={selectedUserId}
            userId={userId}
          />
        );
      case "Mesotherapy":
        return (
          <Mesotherapy
            onBack={() => setSelectedService(null)}
            selectedCustomer={selectedCustomer}
            selectedUserId={selectedUserId}
            userId={userId}
          />
        );
      case "IV Drip Therapy (Standard)":
        return (
          <IVDripTherapy
            onBack={() => setSelectedService(null)}
            selectedCustomer={selectedCustomer}
            selectedUserId={selectedUserId}
            userId={userId}
          />
        );
      case "Laser Treatment":
        return (
          <LaserTreatment
            onBack={() => setSelectedService(null)}
            selectedCustomer={selectedCustomer}
            selectedUserId={selectedUserId}
            userId={userId}
          />
        );
      case "Treatment":
        return (
          <Treatment
            onBack={() => setSelectedService(null)}
            selectedCustomer={selectedCustomer}
            selectedUserId={selectedUserId}
            userId={userId}
          />
        );
      case "Oligio":
        return (
          <Oligio
            onBack={() => setSelectedService(null)}
            selectedCustomer={selectedCustomer}
            selectedUserId={selectedUserId}
            userId={userId}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="pt-0 px-4 pb-4">
      {!selectedService ? (
        <>
          <div className="flex items-center gap-3 mt-[-2px] mb-4">
            <h3 className="text-lg font-semibold">Services Artwork</h3>
            <button
              onClick={onBack}
              className="px-2 py-1 text-xs rounded-full border border-gray-300 text-gray-500 bg-gray-100 hover:bg-gray-200 transition"
            >
              ← Back to Main Asset
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {services.map((s) => (
              <button
                key={s}
                onClick={() => setSelectedService(s)}
                className="w-full border rounded-lg py-3 px-4 text-sm font-medium hover:bg-gray-50 transition text-left"
              >
                {s}
              </button>
            ))}
          </div>
        </>
      ) : (
        <Suspense fallback={<div className="p-4 text-sm text-gray-500">Loading…</div>}>
          {renderSelected()}
        </Suspense>
      )}
    </div>
  );
}
